// extracted by mini-css-extract-plugin
export default {"block":"Pe","flex":"Qe","radio":"Re","label":"Se","error":"Te","extra":"Ue"};